import { FC, Suspense } from "react";
import { lazy } from "react";

import * as Sentry from "@sentry/react";

import ProcedureComparisonSkeleton from "@/components/Procedures/Components/Skeletons/ProcedureComparison/ProcedureComparisonContainerSkeleton";

import PageError from "@/helpers/components/Errors/PageError";

const ProcedureComparisonContainer = lazy(
	() =>
		import(
			"@/components/Procedures/Containers/ProcedureComparison/ProcedureComparisonContainer"
		),
);

export const ProcedureComparisonPage: FC = () => {
	// Fetch the procedure data from the API
	// Both before and after version

	return (
		<>
			<Sentry.ErrorBoundary
				fallback={({ error, resetError, componentStack }) => (
					<PageError
						error={error}
						componentStack={componentStack}
						reset={resetError}
					/>
				)}
			>
				<Suspense fallback={<ProcedureComparisonSkeleton />}>
					<ProcedureComparisonContainer />
				</Suspense>
			</Sentry.ErrorBoundary>
		</>
	);
};

export default ProcedureComparisonPage;
